import {Component, OnInit, ViewChild, ViewEncapsulation, AfterViewInit, ChangeDetectorRef} from "@angular/core";
import {SearchService} from "@app/services/search.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MedOptionType} from "@mk/med-ui";
import {PAGINATION_OPTIONS} from "@app/components/supplies/supplies.component";
import {DomSanitizer} from "@angular/platform-browser";
import {VirtualScroller, VirtualScrollerLazyLoadEvent} from "primeng/virtualscroller";
import {TextSearchDto} from "@app/ui_models/web-response";
import {AccountService} from "@app/services/account.service";

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SearchComponent implements OnInit {

  constructor(public searchService: SearchService,
              private route: ActivatedRoute,
              private accountService: AccountService,
              private router: Router,
              private domSanitizer: DomSanitizer) {
  }

  selectedPageNumber = 1;
  showedOnPage = 10;
  lastPrevious = 0;
  @ViewChild('vs') vs!: VirtualScroller;
  readonly paginationOptions: MedOptionType<number>[] = PAGINATION_OPTIONS;

  text = "Plain Text Example &amp; <strong>Bold Text Example</strong>"


  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const searchTerm = params['searchTerm'] || [''];
      console.log('SearchTerm:', searchTerm);
      if (searchTerm !== this.searchService.searchTerm) {
        this.searchService.searchTerm = searchTerm;
        this.searchService.search();
      } else {
        this.searchService.searchTerm = searchTerm;
      }
    });
  }

  goToDistribution(id: string) {
    if (this.accountService.isDOZ()) {
      this.router.navigate(["/distributions/doz/view/" + encodeURIComponent(id)]);
    } else {
      this.router.navigate(["/distribution/view/" + encodeURIComponent(id)]);
    }
  }

  goToSupply(id: string) {
    this.router.navigate(["/supplies/supply/" + encodeURIComponent(id)]);
  }

  goToReserves(id: string) {
    this.router.navigate(["/reserves/"], {queryParams: {goodId: id, showGoodsSpecifications: true}});
  }

  pageChange(pageNumber: number) {
    this.selectedPageNumber = pageNumber;
    this.searchService.page = pageNumber - 1;
    this.searchService.search();
  }

  getFirstShowedRowIndex(): number {
    return this.selectedPageNumber === 1 ? 0 : (this.selectedPageNumber - 1) * this.searchService.pageSize;
  }

  pageSizeChanged(pageSize: number) {
    this.searchService.pageSize = pageSize;
    this.selectedPageNumber = 1;
    this.searchService.search();
  }

  sanitize(name: string) {
    if (name) {
      name = name.replace("<strong>", "").replace("</strong>", "");
    }
    if (name && name.startsWith("[") && name.endsWith("]")) {
      name = JSON.stringify(JSON.parse(name), null, 4);
      name = '<pre>' + name + '</pre>'
    }
    name = this.transform(name)
    return this.domSanitizer.bypassSecurityTrustHtml(name);
  }

  transform(value: any): any {

    value = this.replaceAll(this.searchService.searchTerm, `<span style="color: maroon; background-color: lightyellow; font-weight: bolder">${this.searchService.searchTerm}</span>`, value)

    return value.replace('<strong>', `<span style="color: maroon; background-color: lightyellow; font-weight: bolder">`)
      .replace('</strong>', `</span>`);
  }

  replaceAll (strReplace: string, strWith: string, value: string) {
    const esc: string = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const reg = new RegExp(esc, 'ig');
    return value.replace(reg, strWith);
  };

  onLazyLoad($event: VirtualScrollerLazyLoadEvent) {
    if (this.lastPrevious < ($event.last || 0)) {
      this.lastPrevious = $event.last || 0;
      if (this.isDivisionResultInteger(this.lastPrevious, 30)) {
        this.searchService.page = this.lastPrevious / 30;

        this.searchService.search($event, this.vs).subscribe(data => {
          if (data) {
            this.searchService.content.push(...this.searchService.splitByChunks(data.content))
            this.searchService.searchInProgress = false;
            if ($event.forceUpdate) {
              $event.forceUpdate();
            }
          }
        });

      }
    }
  }

  scrollto() {
    this.vs.scrollToIndex(10, "smooth")
  }

  isDivisionResultInteger(dividend: number, divisor: number): boolean {
    if (divisor === 0) {
      throw new Error("Cannot divide by zero.");
    }
    const result = dividend / divisor;
    return Number.isInteger(result);
  }

  custom($event: Event) {
    console.log($event)
  }

  showMore() {
    this.searchService.page = this.searchService.page + 1;
    this.searchService.search();
  }

  goTo(result: TextSearchDto) {
    console.log(result);
    switch (result.type) {
      case "distribution": this.goToDistribution(result.id); break;
      case "supply": this.goToSupply(result.id); break;
      case "good": this.goToReserves(result.id); break;
      case "postponed": this.goToPostponed(result.id); break;
      default: console.log("Unknown type: " + result.type);
    }
  }

  private goToPostponed(id: string) {
    this.router.navigate(["/postponed/"], {queryParams: {postponedId: id}});
  }
}
